import React, { useState } from 'react'
import { setModal, selectModal } from "../../redux/modalSlice"
import { useDispatch, useSelector } from 'react-redux'
import Loading from "../../components/Loading";
import Select from 'react-select'
import { useForm, Controller } from 'react-hook-form'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { selectDropdownOptions, selectDropdowns } from "../../redux/dropdownSlice";
import { reactSelectClassNames } from "../../helpers/react-select-styles";
import { generateErrorBody, handleErrorResponse } from "../../helpers/errorHandling";
import { setNotification } from "../../redux/notificationSlice";
import { useRequest } from "../../hooks/UseRequest";
import { useNavigate } from 'react-router-dom'

export default function WireApprovalModal() {
  const dispatch = useDispatch()
  const modal = useSelector(selectModal)
  const paymentId = modal.options?.id;
  const loanNumber = modal.options?.loanNumber;
  const customerId = modal.options?.customerId;
  const loanId = modal.options?.loanId;
  const [saving, setSaving] = useState(false)
  const { handleSubmit, control, reset, setError, formState: { errors, isDirty } } = useForm();
  const dropdownOptions = useSelector(selectDropdownOptions);
  const dropdowns = useSelector(selectDropdowns);
  const wireStatus = dropdowns.data.filter((o) => o.code_key === 'wire_status')[0]
  const wireStatusOptions = dropdownOptions.filter((o) => o.dropdown_id === wireStatus.id).map((o) => ({ label: o.name, value: o.id }))
  const navi = useNavigate()
  const requests = useRequest()

  const handleCancel = async () => {
    reset();
    dispatch(setModal({ is_active: false }));
  };

  const dispatchError = () => {
    if (Object.keys(errors).length > 0) {
      const body = generateErrorBody(errors, [])
      dispatch(setNotification({ type: 'error', body: body }))
    }
  }

  const onSubmit = async (formData) => {
    setSaving(true);
    let formError = false
    if (!formData.wire_tracking_number) {
      setError("wire_tracking_number", { type: "manual" });
      formError = true
    }

    if (formError === true) {
      setSaving(false)
      dispatchError()
      return
    }
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/payment/${paymentId}/update_wire`)
    try {
      // Initialize the request payload
      let body = {
        wire_tracking_number: formData.wire_tracking_number,
        wire_status_dropdown_option_id: wireStatusOptions.find((o) => o.label === 'Sent').value
      }

      // Make the API request
      const response = await requests.edit(body)
      // If the operation was successful, execute the success callback and reset the form
      if (response.status === 200 || response.status === 201 || response.status === 204) {
        setSaving(false)
        handleCancel();
        navi('/payment_schedule/' + customerId)
      } else {
        // If the operation was not successful, show an error notification
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      // If an exception occurs, reset the saving state and show an error notification
      setSaving(false)
      handleErrorResponse(error.response?.data?.errors, setError)
      if (!error.response?.data?.errors) {
        dispatch(setNotification({ type: 'error', body: `Error: ${error.response?.data?.message}` }))
      }
    }
  }

  return modal.is_active && modal.type === 'wire_approval_modal' ? (
    <form onSubmit={handleSubmit(onSubmit)} id="wire_approval_form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card column is-8-tablet is-5-fullhd is-12-mobile">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              Record Wire for Loan #{loanNumber}
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: "100px", overflow: 'hidden' }}
          >
            <p className={'mt-2'}>Enter the wire tracking # and click save to mark the wire as sent.</p>
            <div className="columns mb-0 is-flex-direction-column mt-3">
              <div className="column">
                <div className="field">
                  <label htmlFor="wire_tracking_number">
                    Wire Tracking Number
                    <span className="has-text-danger">*</span>
                    <span
                      style={{ pointerEvents: 'auto' }}
                      className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-top has-tooltip-primary has-text-weight-normal`}
                      data-tooltip={"The individual tracking ID with the bank for this wire transfer transaction."}
                    >
                      <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className={`pl-1 has-text-link`}
                      />
                    </span>
                  </label>
                  <Controller
                    name="wire_tracking_number"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <input {...field} type="text" id="wire_tracking_number" className="input is-small" />
                    )}
                  />
                   <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                     {errors.wire_tracking_number && <span>{errors.wire_tracking_number.message ? errors.wire_tracking_number.message : "Wire Tracking Number is required"}</span>}
                   </p>
                </div>
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button
                type="submit"
                className="button is-link has-text-white is-small ml-2"
                disabled={saving && 'disabled'}
              >
                <span className="mx-3">
                  {saving ? <span> Saving <Loading size={'fa-xs'} noWrapper /> </span> : 'Save'}
                </span>
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="button is-small has-background-grey has-text-white"
              >
                Cancel
              </button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
